// extracted by mini-css-extract-plugin
export default {"root":"wjF2bX","bg":"rGJrqA","left":"SpvDam","right":"LRsKcG"};